module.exports = __webpack_public_path__ + "img/bank_20.21d646ea.png";